<template>
  <label :class="['ms-checkbox', { 'event-none': disabled }]">
    <input
      type="checkbox"
      class="ms-checkbox-control"
      :checked="isChecked"
      :value="isChecked"
      :disabled="disabled"
      v-on="listeners"
    >
    <span 
      v-if="label && isShowLabel" 
      class="ms-checkbox--text"
    >{{ label }}</span>
    <span class="temp-state" />
  </label>
</template>
<script>
import { defineComponent, computed } from 'vue';
export default defineComponent({
  name: 'MsCheckbox',
  props: {
    /**
     * Giá trị của checkBox
     */
    modelValue: {
      default: false,
      type: [Boolean, Number],
    },
    /**
     * Label của checkBox
     */
    label: {
      default: null,
      type: String,
    },
    /**
     * CheckBox có disabled không?
     */
    disabled: {
      default: false,
      type: [Boolean, Function],
    },
    /**
     * CheckBox có được check không?
     */
    checked: {
      type: [Boolean, Number],
      default: false,
    },
    /**
     * Có hiển thị label không?
     */
    isShowLabel: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['update:modelValue', 'change'],
  setup(props, { emit }) {
    /**
     * Hủy lan rộng event
     * HTHIEP 09.02.2022
     */
    const cancelEvent = (e) => {
      if (e) {
        if (typeof e.preventDefault === 'function') {
          e.preventDefault();
        }

        if (typeof e.stopPropagation === 'function') {
          e.stopPropagation();
        }

        if (typeof e.stopImmediatePropagation === 'function') {
          e.stopImmediatePropagation();
        }
      }
    };

    /**
     * Binding Events
     * @author: BMThang(04/12/2022)
     */
    const listeners = computed(() => {
      return {
        input: () => {
          emit('update:modelValue', !props.modelValue);
        },
        change: (event) => {
          cancelEvent(event);
          emit('change', props.modelValue, props.label);
        },
      };
    });

    /**
     * Có đc check hay ko
     * @author: BMThang(04/12/2022)
     */
    const isChecked = computed(() => props.modelValue || props.checked);

    return {
      listeners,
      isChecked,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '@/assets/scss/components/MsCheckbox.scss';
</style>
